import React from 'react';
import _ from 'lodash';
import { Route } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';

import rounts from '.';
import Screen from './Page';

// const advancedMatching = { em: 'bombom.55@hotmail.com' }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const advancedMatching = {}; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: false, // enable logs
};
ReactPixel.init('475053587180605', advancedMatching, options);

class MainRoutes extends React.Component {
  render() {
    return (
      <div id="root-route">
        {rounts.map((item) => {
          return (
            <Route
              key={item.to}
              exact={_.get(item, 'exact', true)}
              path={item.to}
              render={props => <Screen {...props} {...this.props} Page={item.component} />}
            />
          );
        })}
      </div>
    );
  }
}

export default MainRoutes;



// WEBPACK FOOTER //
// ./src/routes/MainRoutes.js